"use strict";

function resizeWindow() {

	var windowHeight = $(window).height();

	if (windowHeight < 670) {
		$("#booking-form").addClass('small-screens');
	} else {
		$("#booking-form").removeClass('small-screens');
	}
}
function scrollDown() {}

$(document).ready(function () {

	$("LINK[href*='css/dialogs.css']").remove();

	if ($("#header").length > 0) {
		setTimeout(function () {
			$("body").addClass("body-ready");
		}, 500);
	}

	equalize();

	//Call function with browser is resized.
	$(window).resize(function (event) {
		resizeWindow();
	});
	resizeWindow();

	//Acts when scroll down page.
	$(window).scroll(function (event) {
		scrollDown();
		var top = $(document).scrollTop();
		if (top > 0) {} else {}
	});

	// 	main menu
	var burger = $('#header .main-menu .burger');
	menu(burger);

	// Main Nav Dropdown
	$("#primary-nav li").hover(function () {

		$(this).addClass("hover");
		$('ul.submenu', this).fadeIn(200);
	}, function () {

		$(this).removeClass("hover");
		$('ul.submenu', this).fadeOut(200);
	});

	//Home page scroll down arrow. If present.
	$('.arrow-home').click(function (event) {
		$('body, html').animate({
			scrollTop: $(window).height() - $('header').outerHeight() * 2 }, 800, 'easeOutExpo');
	});

	//Remove empty <p> tags created by tinymce
	$('p').each(function () {
		var $this = $(this);
		if ($this.html().replace(/\s|&nbsp;/g, '').length == 0) $this.remove();
	});

	// 	$('.Warm-Winter-Escape').insertBefore('.Florida-Resident-Rate');

	//Event Tracking
	//this class should be add to any link to the booking engine
	$('.book-now').on('click', function () {
		if (typeof ga == 'function') ga('send', 'event', 'reservations', 'click', 'book now');
	});
	//this class should be add to the header widget submit button
	$('.bookNow').on('click', function () {
		if (typeof ga == 'function') ga('send', 'event', 'header widget', 'click', 'book now');
	});
	//this class should be add to the beach cam learn more button
	$('.learn-beach-cam').on('click', function () {
		if (typeof ga == 'function') ga('send', 'event', 'beachcam', 'click', 'beachcam');
	});

	//Check in and check out datepicker for booking engine
	$("#CheckIn").datepicker({
		//showOn: "both",
		//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
		//buttonImageOnly: true,
		changeMonth: true,
		numberOfMonths: 2,
		minDate: 0,
		onSelect: function onSelect(selectedDate) {
			getDate = $(this).datepicker('getDate');
			newDate = new Date(getDate.getTime());
			newDate.setDate(newDate.getDate() + 3);
			$("#CheckOut").datepicker("setDate", newDate);
			$("#CheckOut").datepicker("option", "minDate", selectedDate);
		}
	});
	$("#CheckOut").datepicker({
		//showOn: "both",
		//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
		//buttonImageOnly: true,
		changeMonth: true,
		numberOfMonths: 2,
		onSelect: function onSelect(selectedDate) {
			$("#CheckIn").datepicker("option", "maxDate", selectedDate);
		}
	});

	//things to do page


	$("#tabs").tabs({
		activate: function activate(event, ui) {
			$(".blog-post-content").css({
				"opacity": 0,
				"transform": "translateX(-5%)",
				"transition": "all 1s ease-out"
			});
			equalize();
			setTimeout(function () {
				$(".blog-post-content").css({
					"opacity": 1,
					"transform": "translateX(0%)",
					"transition": "all 1s ease-out"
				});
			}, 500);
		}
	});

	// Map: Return to previous page button. Change body id to match map template's name.
	//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');

	//booking
	$('#booking-form ul li').wrapInner('<span></span>');

	$('.btn-booking').click(function () {
		$("#booking-form").fadeIn();
	});

	$('.close-booking').click(function () {
		$("#booking-form").fadeOut();
	});

	$('.btn').wrapInner('<span></span>');

	//book direct home
	$('.book-direct-info ul li').wrapInner('<span></span>');

	//Amenities info
	$('.amenities-content ul li').wrapInner('<span></span>');

	$(".read-more").click(function () {

		var changeTxtBtn = $(this);

		$(this).prev('div.full-content').slideToggle(function () {

			if ($('div.full-content').css("display") == "block") {
				$(changeTxtBtn).text("read less");
			} else {
				$(changeTxtBtn).text("read more");
			}
		});
	});

	//Remove Attributes
	$('#third-nav').removeAttr('aria-labelledby');
});

$(window).on('load', function () {

	//Slick Slider
	$('.sym-slides').slick();
	$('.slide-reasons, .slide-reasons-bg, .slide-specials, .slide-specials-bg').slick();
	equalize();
});